import { Moment } from 'moment';

export const dateSettingsByLocale = {
  de: {
    dateFormat: 'd.m.Y H:i',
    time_24hr: true,
  },
  en: {
    dateFormat: 'm/d/Y h:i K',
    time_24hr: false,
  },
};

export const dataTransferFormat = (date: Moment) =>
  date.format('YYYY-MM-DDTHH:mm:ss');
